import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';
import { MainMenu } from './menu';

function scrollToAccordion() {
    document.querySelectorAll('.content-accordion .toggler').forEach((el) =>
        el.addEventListener('click', function () {
            if (!window.innerWidth < MainMenu.breakPoint || this.classList.contains('ui-state-active')) {
                return;
            }

            setTimeout(() => {
                ScrollUtil.scrollToTarget(this, -8, 600);
            }, 450);
        })
    );
}

onDomReady(() => {
    scrollToAccordion();
});
